import React from 'react';
import { Col, Menu, Row, Typography } from 'antd';
import { Link } from 'react-scroll';
import './index.less';
import SliderMenu from '../../components/Menu';
import SocialMedia from '../../components/SocialMedia';

class Banner extends React.PureComponent {
  state = {
    rows: 1,
    readMore: false,
  };

  getMoreRead = rows => {
    const { readMore } = this.state;
    this.setState({ rows, readMore: !readMore });
  };

  render() {
    const { Title, Paragraph } = Typography;
    const paragraph =
      '. . .maximizing transformer asset value for every kWh';

    return (
      <Row className="header-box">
        <Col
          xxl={11}
          xl={{ span: 12, offset: 0 }}
          lg={14}
          md={{ span: 20, offset: 1 }}
          sm={{ span: 20, offset: 1 }}
          xs={23}
          className="navigation"
        >
          <nav className="menuBar">
            <SliderMenu />
          </nav>
        </Col>
        <Col xxl={12} xl={12} lg={9} className="socialMedia">
          <Typography className="follow font-color">
            <Title level={3} className="follow">
              Follow Us :
            </Title>
          </Typography>
          <span className="social-icon">
            <SocialMedia />
          </span>
        </Col>
        <Row>
          <Col
            id="goHome"
            xxl={{ span: 13, offset: 2 }}
            xl={15}
            lg={{ span: 15, offset: 2 }}
            md={{ span: 17, offset: 2 }}
            sm={{ span: 18, offset: 4 }}
            xs={22}
            className="header-content"
          >
            <div className="content-block font-color">
              <Typography>
                <Title level={1}>Intelligent Power Transfer:</Title>
                <div>
                  <Paragraph className="read-content">{paragraph}</Paragraph>
                  <button className="Shedule-Btn demo-Btn">
                    <Link to="goContactUs" spy smooth duration={500} delay={500}>
                      <span>Contact us</span>
                    </Link>
                  </button>
                </div>
              </Typography>
            </div>
          </Col>
        </Row>
      </Row>
    );
  }
}

export default Banner;
